import { SET_ACTIVE_TAB } from 'root/src/client/logic/tab/actionIds'

export default (moduleId, endpointId) => ({
	type: SET_ACTIVE_TAB,
	payload: { moduleId, endpointId },
})
